import { User } from "../models";

// The access token lives in memory only (not localStorage) so an XSS payload cannot read it;
// the http-only refresh cookie is the sole persistent credential and rebuilds the session on
// load (see the bootstrap flow). The non-credential `user` cache stays in localStorage because
// ACL.tsx and the shared saga read it synchronously outside of React state.
let _token: string | null = null;

export default {
  get: (): string | null => _token,
  set: (token: string) => {
    if (token) _token = token;
  },
  setUser: (user: User) => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
  },
  getUser: () => {
    const user = localStorage.getItem("user");

    return user ? JSON.parse(user) : null;
  },
  remove: () => {
    _token = null;
  },
  removeAll: () => {
    _token = null;
    localStorage.clear();
  },
};
